module.exports = __webpack_public_path__ + "static/CodeCup3-3f5ebb550409b3ca500a144b52ad281b.jpg";